import {Directive, effect, ElementRef, inject, input} from "@angular/core";

function stopPropagation(event: Event) {
	event.stopPropagation();
}

@Directive({
	selector: "[appStopPropagation]",
	standalone: true,
})
export class StopPropagationDirective {
	public readonly stopPClick = input(true);
	public readonly stopPMouseOver = input(true);
	public readonly stopPKeyDown = input(false);

	readonly #elRef = inject<ElementRef<HTMLElement>>(ElementRef);

	readonly #stopClickEffect = effect((onCleanup) => {
		if (this.stopPClick()) {
			this.#elRef.nativeElement.addEventListener("click", stopPropagation);
			onCleanup(() => this.#elRef.nativeElement.removeEventListener("click", stopPropagation));
		}
	});

	readonly #stopMouseOverEffect = effect((onCleanup) => {
		if (this.stopPMouseOver()) {
			this.#elRef.nativeElement.addEventListener("mouseover", stopPropagation);
			onCleanup(() => this.#elRef.nativeElement.removeEventListener("mouseover", stopPropagation));
		}
	});

	readonly #stopKeyDownEffect = effect((onCleanup) => {
		if (this.stopPKeyDown()) {
			this.#elRef.nativeElement.addEventListener("keydown", stopPropagation);
			onCleanup(() => this.#elRef.nativeElement.removeEventListener("keydown", stopPropagation));
		}
	});
}
